import React, { FC, SVGProps } from 'react';

export const StayOnTrack: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="88" height="88" rx="44" fill="#BAE1D1" />
    <rect
      x="32"
      y="34"
      width="30"
      height="13"
      rx="6.5"
      transform="rotate(90 32 34)"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect
      x="50"
      y="25"
      width="39"
      height="12"
      rx="6"
      transform="rotate(90 50 25)"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect
      x="69"
      y="32"
      width="32"
      height="13"
      rx="6.5"
      transform="rotate(90 69 32)"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
